module.exports = __webpack_public_path__ + "img/shop.9c18bf1c.png";